import t from "./ghl-ui.es1234.js";
var e = t(Object.getPrototypeOf, Object);
const r = e;
export {
  r as default
};
